import React from "react";
import PropTypes from "prop-types";
import ListingDetailsBrief from "../../../../../components/ListingDetailsBrief/ListingDetailsBrief";
import ListingPrice from "../../../../../components/ListingPrice/ListingPrice";
import ShortlistButton from "../../../../../components/Shortlist/ShortlistButton";
import StudentExclusivePill from "../../../../../components/StudentExclusivePill/StudentExclusivePill";
import { create as createListingViewModel } from "../../../../../utils/listing-view-model";

function ListingDetailsCard({ t, lang, listing, onClick = (x) => x }) {
  const { title, price, currency, pictures } = listing;
  const lvm = createListingViewModel(t, lang);
  const listingHref = lvm.permalinkUrl(listing);

  return (
    <article className="ListingDetailsCard" data-testid="ListingDetailsCard">
      {listing.restrictions && listing.restrictions.onlyStudentsAllowed && (
        <StudentExclusivePill t={t} short />
      )}
      <a
        href={listingHref}
        className="ListingDetailsCard-linkArea"
        onClick={(e) => onClick(e)}
      >
        <div className="ListingDetailsCard-images">
          {pictures.map((img) => (
            <img
              className="ListingDetailsCard-imageItem"
              key={img.imageId}
              src={img.urls.thumbnail}
            />
          ))}
        </div>
        <div className="ListingDetailsCard-info">
          <h3 className="ListingDetailsCard-title">{title[lang] || ""}</h3>
          <ListingPrice
            className="ListingDetailsCard-price"
            light
            t={t}
            price={price}
            currency={currency}
          />
          <ListingDetailsBrief t={t} listing={listing} />
        </div>
      </a>
      <ShortlistButton
        eventLabel="Listing Detail Page"
        className="ListingDetailsCard-shortlistButton"
        groupId={listing.groupId}
        t={t}
        url={() => {}}
        data-testid="ListingDetailsCard-shortlistButton"
      />
    </article>
  );
}

ListingDetailsCard.propTypes = {
  t: PropTypes.func,
  lang: PropTypes.string,
  listing: PropTypes.object,
  onClick: PropTypes.func,
};

export default ListingDetailsCard;
